import { createSelector } from "reselect";
import { createMakeSelectCurrentPage } from "lib/providers/pagination-provider/selectors";
import { makeSelectEntityStatuses } from "entities/entity_status/selectors";
import { makeSelectTranslation } from "../translation/selectors";
import { makeSelectStringSource } from "../stringResources/selectors";

const selectEntity = state => state.entities.alg_principle;
const selectEntityData = state =>
  state.entities.alg_principle ? state.entities.alg_principle.data : [];

export const makeSelectPrinciple = paginationKey =>
  createSelector(
    [
      selectEntityData,
      createMakeSelectCurrentPage(paginationKey)(),
      makeSelectEntityStatuses(),
      makeSelectStringSource(),
      makeSelectTranslation()
    ],
    (substate, page, statuses, resources, translations) => {
      if (!paginationKey) {
        return substate;
      }

      if (page.length > 0)
        return page
          .map(id => {
            if (!substate[id]) {
              return null;
            }

            const principle = { ...substate[id] };
            principle.entity_status = statuses[principle.entity_status.id];
            for (let string of resources) {
              if (string.id === principle.name)
                principle.string_resources = string;
            }
            const newTranslations = [];
            for (let translation of principle.string_resources.translations) {
              newTranslations.push(translations[translation.id]);
            }
            principle.string_resources.translations = newTranslations;

            return principle;
          })
          .filter(row => row);
    }
  );

export const makeSelectPrincipleLoading = () =>
  createSelector(selectEntity, substate => {
    if (substate) return substate.isLoading;
  });
